
/**
 *      Data-driven UI logic to display top-level categories (with data types)
 *
 *      @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *      Created on 09/13/2017
 *      Modified on 08/01/2018
 */


/***
 * Display initial data types (pre-ordered)
 * @param response {object} - ElasticSearch response object that contains all DMR models
 */
function displayInitialDataTypes( response ) {
    var data;
    if ( response ) {

        data = response.aggregations;
        // Get data types either from DMR or use local ones if DMR call fails
        getDataTypes( displayServerDataTypes( data ), dataNotFound( "Get data types URL" ));
    }

}

/**
 * Get data types from the Data Model Registry models by category
 * @param successCallback {Function} - function that gets called on success
 * @param failureCallback {Function} - function that gets called on failure
 */
function getDataTypes( successCallback, failureCallback ) {
    var url = "/dmr/api/v1/modelsbycategory";
    makeAjaxRequest( url, successCallback, failureCallback );
}

/**
 * Display data types from DMR
 * @param response {object} - ElasticSearch response object that contains aggregations
 * @returns {Function}
 */
function displayServerDataTypes( response ) {
    /**
     * Callback that is called when the call to get data types from Data Model Registry succeeds
     * @param data {Array} - data models JSON object
     * @param textStatus {string} - status of the request
     * @param jqXHR {object} - jQuery XMMLHTTPRequest object
     */
    return function( data, textStatus, jqXHR ) {
        getDataTypeCategories( response, data );
    };
}

/**
 * Get data types categories
 * @param data {object} - Search API response object
 * @param modelsByCategory {object} - all DMR categories and their models
 */
function getDataTypeCategories( data, modelsByCategory ) {

    var filtersElId = '#available-filters',
        filtersLayout = new FiltersLayoutView( { el: filtersElId } );

    // Display models by their category
    // Don't need to fetch DMR models to get model label
    // Use the model objects in the modelsbycategory response

    if ( data && data.types && data.types.buckets && data.types.buckets.length > 0 && modelsByCategory ) {
        // If there's only one type, check its documenet count
        if ( data.types.buckets[0] && data.types.buckets[0].doc_count === 0 ) {
            displayEmptyFilters( filtersLayout, $( filtersElId ), 'empty-available-filters' );
        } else {
            displayModelCategories( data.types.buckets, modelsByCategory, filtersElId, filtersLayout );
        }
    }
    else {
        displayEmptyFilters( filtersLayout, $( filtersElId ), 'empty-available-filters' );
    }
}

/**
 *
 * @param data {Array} - array of objects { key: {string}, doc_count: {number} }
 * @param modelsByCategory {object} - key is the category name, value is an array of objects
 * @param filtersElId {string} - DOM element id of the filters element
 * @param filtersLayout {object} - filters layout where regions are rendered
 */
function displayModelCategories( data, modelsByCategory, filtersElId, filtersLayout ) {

    var displayCategories = {},
        key,
        category,
        categoryObject,
        categoryName,
        categoryPosition,
        categoryTypes,
        categoriesArray,
        sortedCategories,
        filters;

    // Iterate through each object in the modelsByCategory
    // Create a new object displayCategories that contains type counts of each category models

    for ( key in modelsByCategory ) {
        if ( modelsByCategory.hasOwnProperty( key ) )  {
            category = modelsByCategory[ key ];
            if ( category && Array.isArray( category ) && category.length > 0 ) {

                // The first item in the category is the category display name
                categoryObject = category[0];
                if ( categoryObject ) {
                    categoryName = categoryObject.name;
                    categoryPosition = categoryObject.position;
                    if ( ! categoryPosition )  {
                        categoryPosition = 1000; // Default category position value
                    }
                    // Add new category to the displayCategories object
                    if ( categoryName && ! ( displayCategories[ categoryName ] ) ) {
                        displayCategories[ categoryName ] = {};
                        displayCategories[ categoryName ].label = categoryName;
                        displayCategories[ categoryName ].position = categoryPosition;

                        // Get types that have search results for the category
                        categoryTypes = getCategoryTypes( category, categoryName, data );
                        displayCategories[ categoryName ].types = categoryTypes;

                        // Remove category that has no types
                        if ( Object.keys( categoryTypes ).length === 0 ) {
                            delete displayCategories[ categoryName ];
                        }
                    }
                }
            }
        }
    }

    categoriesArray = $.map( displayCategories, function ( value, index ) {
        return [ value ];
    });

    sortedCategories = categoriesArray.sort( compareByPosition );

    // Display categories and their types
    filters = displayDataTypesAggregation( sortedCategories );

    displayFacets( "type", filtersElId, filtersLayout, filters, null );

    // Select checked types
    if ( filters ) {
        styleFiltersLayout( filters.length, filtersElId );
    }
}


/**
 * Get category types
 * @param category {Array} - array of objects for one category
 * @param categoryName {string} - category name/label
 * @param data {Array} - array of objects { key: {string}, doc_count: {number} }
 * @returns {object} - category types
 */
function getCategoryTypes( category, categoryName, data ) {

    var types = {},
        categoryTypeObject,
        typeCategory,
        typePosition,
        modelName,
        modelLabel,
        typeCount,
        i;

    // The first item in the category array is the name and position of the category
    // The rest of the items in the category is category types
    for ( i = 1; i < category.length; i++ ) {
        categoryTypeObject = category[ i ];

        if ( categoryTypeObject ) {
            typeCategory = categoryTypeObject.category;

            if ( typeCategory ) {
                if ( typeCategory.label === categoryName ) {
                    typePosition = typeCategory.position;

                    // check that type position is defined
                    if ( ! typePosition ) {
                        typePosition = 1000; // default value
                    }

                    modelName = categoryTypeObject.name;
                    modelLabel = categoryTypeObject.short_name;
                    if ( ! modelLabel ) {
                        modelLabel = categoryTypeObject.label;
                    }

                    // Get the number of results found
                    // Models that do not exist will have 0 results
                    typeCount = getTypeCount( data, modelName );

                    if ( typeCount > 0 ) {
                        // add model name as the key to the types object
                        if ( modelName && modelLabel && typePosition ) {
                            types[ modelName ] = {};
                            types[ modelName ].label = modelLabel;
                            types[ modelName ].position = typePosition;
                            types[ modelName ].count = typeCount;
                        }
                    }
                }
            }
        }
    }
    return types;
}

/**
 * Compare two category objects by their position attribute
 * @param a {object} - data category object
 * @param b {object} - data category object
 * @returns {number}
 */
function compareByPosition( a, b ) {

    if ( a && b ) {
        if ( a.position < b.position ) {
            return -1;
        } else if ( a.position > b.position ) {
            return 1;
        }
    }
    return 0;
}

/**
 * Return the number of search results found for a particular data type
 * @param data {Array} - array of objects { key: {string}, doc_count: {number} }
 * @param name {string} - data type name
 * @return {number}
 */
function getTypeCount( data, name ) {
    var result = 0,
        key,
        dataObject;

    if ( data && name ) {
        for ( key in data ) {
            if ( data.hasOwnProperty( key ) ) {
                dataObject = data[ key ];
                if ( dataObject ) {
                    if ( dataObject.key === name ) {
                        return dataObject.doc_count;
                    }
                }
            }
        }
    }
    return result;
}